// Rank	Superstars	Date Won
// 1	Becky Lynch	9 / 11 / 2016
// 2	Alexa Bliss	12 / 4 / 2016
// 3	Naomi	2 / 12 / 2017
// —	Vacated	2 / 21 / 2017
// 4	Alexa Bliss	2 / 21 / 2017
// 5	Naomi	4 / 2 / 2017
// 6	Natalya	8 / 20 / 2017
// 7	Charlotte Flair	11 / 14 / 2017
// 8	Carmella	4 / 10 / 2018
// 9	Charlotte Flair	8 / 19 / 2018
// 10	Becky Lynch	9 / 16 / 2018
// 11	Asuka	12 / 16 / 2018
// 12	Charlotte Flair	3 / 26 / 2019
// 13	Becky Lynch	4 / 8 / 2019
// 14	Charlotte Flair	5 / 19 / 2019
// 15	Bayley	5 / 19 / 2019
// 16	Charlotte Flair	10 / 6 / 2019
// 17	Bayley	10 / 11 / 2019
// 18	Sasha Banks	10 / 25 / 2020
// 19	Bianca Belair	4 / 10 / 2021
// 20	Becky Lynch	8 / 21 / 2021
// 21	Charlotte Flair	10 / 22 / 2021
// 22	Ronda Rousey	5 / 8 / 2022
// 23	Liv Morgan	7 / 2 / 2022
// 24	Ronda Rousey	10 / 8 / 2022
// 25	Charlotte Flair	12 / 30 / 2022
// 26	Rhea Ripley	4 / 1 / 2023
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
let x = 1;
const titlePrefix = "world-womens";
const championshipId = "womens-world-championship";
const _default = [
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "becky-lynch"
        ],
        championshipId,
        startDate: new Date("Apr 22, 2023")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "rhea-ripley"
        ],
        championshipId,
        endDate: new Date("Apr 15, 2024"),
        startDate: new Date("Apr 1, 2023")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "charlotte-flair"
        ],
        championshipId,
        startDate: new Date("Dec 30, 2022"),
        endDate: new Date("Apr 1, 2023")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "ronda-rousey"
        ],
        championshipId,
        startDate: new Date("Oct 8, 2022"),
        endDate: new Date("Dec 30, 2022")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "liv-morgan"
        ],
        championshipId,
        startDate: new Date("Jul 2, 2022"),
        endDate: new Date("Oct 8, 2022")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "ronda-rousey"
        ],
        championshipId,
        startDate: new Date("May 8, 2022"),
        endDate: new Date("Jul 2, 2022")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "charlotte-flair"
        ],
        championshipId,
        startDate: new Date("Oct 22, 2021"),
        endDate: new Date("May 8, 2022")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "becky-lynch"
        ],
        championshipId,
        startDate: new Date("Aug 21, 2021"),
        endDate: new Date("Oct 22, 2021")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "bianca-belair"
        ],
        championshipId,
        startDate: new Date("Apr 10, 2021"),
        endDate: new Date("Aug 21, 2021")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "sasha-banks"
        ],
        championshipId,
        startDate: new Date("Oct 25, 2020"),
        endDate: new Date("Apr 10, 2021")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "bayley"
        ],
        championshipId,
        startDate: new Date("Oct 11, 2020"),
        endDate: new Date("Oct 25, 2020")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "charlotte-flair"
        ],
        championshipId,
        startDate: new Date("Oct 6, 2019"),
        endDate: new Date("Oct 11, 2020")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "bayley"
        ],
        championshipId,
        startDate: new Date("May 19, 2019"),
        endDate: new Date("Oct 6, 2019")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "charlotte-flair"
        ],
        championshipId,
        startDate: new Date("May 19, 2019"),
        endDate: new Date("May 19, 2019")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "becky-lynch"
        ],
        championshipId,
        startDate: new Date("Apr 8, 2019"),
        endDate: new Date("May 19, 2019")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "charlotte-flair"
        ],
        championshipId,
        startDate: new Date("Mar 26, 2019"),
        endDate: new Date("Apr 8, 2019")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "asuka"
        ],
        championshipId,
        startDate: new Date("Dec 16, 2018"),
        endDate: new Date("Mar 26, 2019")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "becky-lynch"
        ],
        championshipId,
        startDate: new Date("Sep 16, 2018"),
        endDate: new Date("Dec 16, 2018")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "charlotte-flair"
        ],
        championshipId,
        startDate: new Date("Aug 19, 2018"),
        endDate: new Date("Sep 16, 2018")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "carmella"
        ],
        championshipId,
        startDate: new Date("Apr 10, 2018"),
        endDate: new Date("Aug 19, 2018")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "charlotte-flair"
        ],
        championshipId,
        startDate: new Date("Nov 14, 2017"),
        endDate: new Date("Apr 10, 2018")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "natalya"
        ],
        championshipId,
        startDate: new Date("Aug 20, 2017"),
        endDate: new Date("Nov 14, 2017")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "naomi"
        ],
        championshipId,
        startDate: new Date("Apr 2, 2017"),
        endDate: new Date("Aug 20, 2017")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "alexa-bliss"
        ],
        championshipId,
        startDate: new Date("Feb 12, 2017"),
        endDate: new Date("Apr 2, 2017")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "alexa-bliss"
        ],
        championshipId,
        startDate: new Date("Dec 4, 2016"),
        endDate: new Date("Feb 12, 2017")
    },
    {
        id: `${titlePrefix}-${x++}`,
        wrestlerIds: [
            "becky-lynch"
        ],
        championshipId,
        startDate: new Date("Sep 11, 2016"),
        endDate: new Date("Dec 4, 2016")
    }
];
